module.exports = __webpack_public_path__ + "img/purple-circle-table-1.79d7c0cd.png";